import React from "react";
import badgeImage from "../assets/badge-transparent.png";
import houseBadgeImage from "../assets/house-helper-badge-transparent.png";
import { useBrand } from "../branding/BrandContext";


export default function HomeHelperBadge() {
  const brand = useBrand();
  const image = brand.brandKey === "house-helper" ? houseBadgeImage : badgeImage;

  return (
    <div className="hh-badge">
      <img
        src={image}
        alt={`${brand.brandName} — Trusted, Transparent, Homeowner-First`}
        className="hh-badge-image"
      />
    </div>
  );
}
